// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Aniversariantes_EnviarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /aniversariantes/enviar
 *
 * Returns the ID of the created send record.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Aniversariantes_EnviarResponseDados {
envio_id: number
}

export type Aniversariantes_EnviarResponse = ApiResponse<Aniversariantes_EnviarResponseDados>;

registerResponseContract('Aniversariantes_EnviarResponse', {
  envio_id: { type: 'number',  required: true },
})
